// extracted by mini-css-extract-plugin
export var layoutContainer = "_4x-0";
export var layoutContainerNoRounding = "_4x-6";
export var layoutContainerOpen = "_4x-5";
export var layoutContainerResizing = "_4x-1";
export var mainContent = "_4x-2";
export var resizeDivider = "_4x-3";
export var slidePanel = "_4x-4";